import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { featureName } from './types';
import { reducers } from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { CustomerEffects } from './effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature(featureName, reducers), EffectsModule.forFeature([CustomerEffects])]
})
export class CustomerModule {}
